import React from 'react';
import {
    SyncMapsCard,
    SyncMapsConsolidatedResponse,
    SyncMapStatus,
} from '../../../views/sync-maps-updates-view/hooks/use-syncs-maps-status-updates';
import caution from '../../../assets/caution-alert.svg';
import checkmarkSecondary from '../../../assets/checkmark-secondary.svg';
import './sync-maps-update-accordion.scss';
import { SyncMapsUpdateAccordionItemContainer } from './sync-maps-update-accordion-item-container';
import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';

interface Props {
    setSelectedOption?: (event: any) => void;
    ctrUnavailableMapUpdate?: boolean;
    selectedOption?: string;
    hasSync?: boolean;
    hasCtr?: boolean;
    hasVw?: boolean;
    hasUpdate?: boolean;
    syncGeneration?: string;
    cards: SyncMapsCard[] | [];
    heading?: string;
    title?: string;
    subtitle?: string;
    radioButtons?: boolean;
    upToDate?: string;
    syncMapContent?: SyncMapStatus | null;
    downloadUrl?: string;
    notAvailable?: string;
    accordionType?: string;
    disabled?: boolean;
    version?: boolean;
    eulaURL?: string;
    downloadUrlError?: boolean;
    releaseDate?: string;
    syncMapsConsolidatedResponse?: SyncMapsConsolidatedResponse;
}

const SyncMapsUpdateAccordion = (props: Props) => {
    const isNA = new AppConfigurationService().isRegionNA();

    return (
        <div className={`sync-map-accordion`}>
            <h2 className={`sync-maps-header-one`}>{props.heading}</h2>
            {props.hasSync || props.hasCtr || props.hasVw ? (
                <div className="sync-has-update">
                    {props.hasUpdate ? (
                        <>
                            {!props.downloadUrlError ? (
                                <SyncMapsUpdateAccordionItemContainer
                                    syncMapContent={props.syncMapContent}
                                    accordionType={props.accordionType}
                                    title={props.title}
                                    cards={props.cards}
                                    disabled={props.disabled}
                                    radioButtons={props.radioButtons}
                                    selectedOption={props.selectedOption}
                                    setSelectedOption={props.setSelectedOption}
                                    syncGeneration={props.syncGeneration}
                                    version={props.version}
                                    hasCtr={props.hasCtr}
                                    hasVw={props.hasVw}
                                    eulaURL={props.eulaURL}
                                    downloadUrl={props.downloadUrl}
                                    subtitle={props.subtitle}
                                    heading={props.heading}
                                    isNA={isNA}
                                />
                            ) : (
                                <div className="sync-up-to-date">
                                    <img
                                        className="sync-up-to-date-img"
                                        src={caution}
                                        alt=""
                                        loading="lazy"
                                        height={24}
                                        width={24}
                                    />
                                    <p className="sync-up-to-date-title">
                                        {
                                            props.syncMapContent
                                                ?.apiDownloadUrlError
                                        }
                                    </p>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="sync-up-to-date">
                            <img
                                className="sync-up-to-date-img"
                                src={checkmarkSecondary}
                                alt=""
                                loading="lazy"
                                height={24}
                                width={24}
                            />
                            <p className="sync-up-to-date-title">
                                {props.upToDate}
                            </p>
                        </div>
                    )}
                </div>
            ) : (
                <>
                    {props.ctrUnavailableMapUpdate ? (
                        <div className="sync-up-to-date">
                            <img
                                className="sync-up-to-date-img"
                                src={checkmarkSecondary}
                                alt=""
                                loading="lazy"
                                height={24}
                                width={24}
                            />
                            <div>
                                <p className="sync-up-to-date-title">
                                    <span>
                                        {
                                            props.syncMapContent
                                                ?.ctrMapsNotAvailable
                                        }
                                    </span>
                                </p>
                                <p>
                                    <span className="sync-up-to-date-subtitle">
                                        <span className="redText">
                                            {
                                                props.syncMapContent
                                                    ?.ctrMapsNotAvailableDescription
                                            }
                                        </span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="sync-up-to-date">
                            <img
                                className="sync-up-to-date-img"
                                src={checkmarkSecondary}
                                alt=""
                                loading="lazy"
                                height={24}
                                width={24}
                            />
                            <div>
                                <p className="sync-up-to-date-title">
                                    {props.notAvailable}
                                </p>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
export default SyncMapsUpdateAccordion;
